/**
 * Upload an image to /api/v1/preferences/upload-image and return the
 * proxy URL ready to store on the user / org record.
 */
import api from '../api/client';

export async function uploadImage(file, category = 'misc') {
  if (!file) throw new Error('No file provided');
  const fd = new FormData();
  fd.append('file', file);
  fd.append('category', category);
  const res = await api.post('/preferences/upload-image', fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return res.data; // { url, s3_key, size_bytes, content_type }
}

export function formatBytes(bytes) {
  if (bytes === 0 || bytes == null) return '0 B';
  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.min(Math.floor(Math.log(bytes) / Math.log(k)), sizes.length - 1);
  return `${(bytes / Math.pow(k, i)).toFixed(i === 0 ? 0 : 1)} ${sizes[i]}`;
}
